// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.79.0/styles/" + (chunkId === 653 ? "videojs" : chunkId) + ".chunk.css?" + {"598":"e48a3919bacf5bb72238","653":"750e356339e668085955"}[chunkId] + "";
};